import TabPanelComponents from '../TabPanelComponents';
import TabPanelHealth from '../TabPanelHealth';
import TabPanelParts from '../TabPanelParts';
import TabPanelService from '../TabPanelService';
import TabPanelWarnings from '../TabPanelWarnings';

import { VerticalContainer } from '@american-autonomy/ag-ui';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const DrawerTabBody: FunctionComponent<Props> = ({
    activeTab,
    className = '',
    drone,
    droneNames,
    isAdmin,
    onAdd,
    onEditRecord,
    onOpenLogService,
    onVoidRecord,
    phase,
    records,
    serviceIntervals,
    testId = TEST_ID
}) => (
    <VerticalContainer className={`${styles.drawerBody} ${className}`} testId={testId}>
        {activeTab === 'health' && (
            <TabPanelHealth drone={drone} phase={phase} serviceIntervals={serviceIntervals} />
        )}

        {activeTab === 'components' && (
            <TabPanelComponents drone={drone} phase={phase} serviceIntervals={serviceIntervals} />
        )}

        {activeTab === 'service' && (
            <TabPanelService
                drone={drone}
                isAdmin={isAdmin}
                onEditRecord={onEditRecord}
                onOpenLogService={onOpenLogService}
                onVoidRecord={onVoidRecord}
                records={records}
                serviceIntervals={serviceIntervals}
            />
        )}

        {activeTab === 'parts' && (
            <TabPanelParts
                drone={drone}
                droneNames={droneNames}
                onAdd={onAdd}
                phase={phase}
                serviceIntervals={serviceIntervals}
            />
        )}

        {activeTab === 'warnings' && <TabPanelWarnings drone={drone} />}
    </VerticalContainer>
);

export default DrawerTabBody;
